var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKwdFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.994h90v15.003H0V14.994Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 29.997h90V45H0V29.997Z",
    fill: "#F31830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90v15.003H0V0Z",
    fill: "#00D941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v45l22.447-15.003.053-15.012L0 0Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwdFlag);
export default __webpack_public_path__ + "static/media/kwd-flag.08751a4b19cb478082ae5c1650244c74.svg";
export { ForwardRef as ReactComponent };